module.exports = {render:function anonymous(
) {
with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-labelledby":"check","viewBox":"0 0 23 23"}},[_c('title',[_v("check")]),_c('path',{attrs:{"d":"M9.815 19.031L3.333 12.55l.707-.707 5.628 5.626 9.173-13.5.826.562z"}})])}
}};